import React from 'react';
import $ from 'jquery';
import styles from '../signature_pad/styles.css'
import SignaturePad from 'react-signature-canvas'

import {
    Button,
} from 'react-bootstrap';

export default class SignaturePadToData extends React.Component {
  sigPad = {}

  constructor(props){
    super(props);
    this.state = {trimmedDataURL: null};
  }

  clear = () => {
    this.sigPad.clear()
  }

  getCookie = (c_name) => {
      if(document.cookie.length > 0) {
          let c_start = document.cookie.indexOf(c_name + "=");
          if(c_start != -1) {
              c_start = c_start + c_name.length + 1;
              let c_end = document.cookie.indexOf(";", c_start);
              if(c_end == -1) c_end = document.cookie.length;
              return unescape(document.cookie.substring(c_start,c_end));
          }
      } else {
          return "";
      }
  }

  submitSignature = () => {
      let field = this.props.field;
      let url = this.props.url;
      let cookie = this.getCookie('csrftoken');
      let data = {}
      data[field] = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
      $.ajax({
          url: url,
          dataType: 'json',
          method: 'PUT',
          headers: {"X-CSRFToken": cookie},
          data: data,
          cache: false,
          success: (data) => {
            //console.log('We submitted a handleSubmitClick');
            this.setState({redirect: true})
            this.props.clearEditingInstance();
            this.props.setMessage(this.props.message, 'success');
          },
          error: (xhr, status, err) => {}
      });
  }

  render () {
    let trimmedDataURL = this.state.trimmedDataURL;
    return (
        <div className={styles.container}>
          <div className={styles.sigContainer} bsStyle='default' style={this.props.canvas_style}>
            <SignaturePad canvasProps={{className: styles.sigPad}}
              ref={(ref) => { this.sigPad = ref }} />
          </div>
          <div>
            <Button className={styles.buttons} onClick={this.clear}>
              Clear
            </Button>
            <Button className={styles.buttons} bsStyle='success' onClick={this.submitSignature} style={{marginLeft:5}}>
              Submit
            </Button>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/signature_pad.js